import { ModalCommonProps } from 'components/modals/RootModal';
import ChangePricingPlanOnlyPaidModal from 'features/pricing/modals/ChangePricingPlanOnlyPaidModal';

type Props = ModalCommonProps;

export const UpdateSubscriptionFromWordsLimitUsedModal = ({ closeModal }: Props) => (
  <ChangePricingPlanOnlyPaidModal onClose={closeModal} />
);
